import dotProp from 'dot-prop'
import { createSelector } from 'reselect'

const getKeyWindowIds = (entityName, keyWindow) => {
  return (state) => {
    return dotProp.get(state, `meta.${entityName}.keyWindows.byWindow.${keyWindow}.allIds`)
  }
}

export const getKeyWindowSelector = (entityName,  keyWindow, getEntities) => {
  return  createSelector([getEntities, getKeyWindowIds(entityName, keyWindow)], (entities, ids) => {
    if (!ids) {
      return []
    }

    const entitiesById = entities.reduce((result, entity) => {
      result[entity.id.toString()] = entity
      return result
    }, {})

    return ids.map((id) => entitiesById[id.toString()]).filter(Boolean)
  })
}
